var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","height":"90vh","width":"90vw"}},[_c('img',{staticStyle:{"width":"60%"},attrs:{"src":require("@/assets/404/not_found.png")}})])
}]

export { render, staticRenderFns }